module.exports = __webpack_public_path__ + "static/top-loslogo-67d8d51b908da5792086e3e7aab0636a.gif";